import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { map } from "rxjs/operators";
import { UserForm } from "app/interfaces/user-form.interface";

const masterIncidentDestinationUrlApi =
  environment.masterIncidentDestinationUrlApi;
const masterIncidentMotivationUrlApi =
  environment.masterIncidentMotivationUrlApi;
const masterIncidentReasonUrlApi = environment.masterIncidentReasonUrlApi;
const masterIncidentStatusUrlApi = environment.masterIncidentStatusUrlApi;

@Injectable()
export class MasterMainService {
  public user: UserForm;

  constructor(
    private http: HttpClient,
  ) {}

  getMasterIncidentDestination() {
    return this.http
      .request("GET", `${masterIncidentDestinationUrlApi}`, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  getMasterIncidentMotivation() {
    return this.http
      .request("GET", `${masterIncidentMotivationUrlApi}`, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }
  getMasterIncidentReason() {
    return this.http
      .request("GET", `${masterIncidentReasonUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }
  getMasterIncidentStatusModel() {
    return this.http
      .request("GET", `${masterIncidentStatusUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }
}
